import { Button } from "components/Button/Button";
import { getUpdatedData } from "components/Form/components/SchemaForm/SchemaFormService";
import { IconCollection } from "components/Icon/IconCollection";
import { SchemaFieldTypeExtended } from "config/config";
import { FilterFragment } from "containers/Filter/FilterBuilder/components/FilterFragment";
import { emptyExists, emptyField } from "containers/Filter/FilterBuilder/constants";
import { useMatchingRelations } from "containers/Filter/FilterBuilder/useMatchingRelations";
import { FormApi } from "final-form";
import { Field, Form as FinalForm, FormSpy } from "react-final-form";
import { ClearSearchButton } from "../../Filter/components/ClearSearchButton";

interface CustomFilterFieldProps {
    form: FormApi | null;
    matchingFields: SchemaFieldTypeExtended[];
    filteredFieldList: { value: string; label: any }[];
    values: any;
    clearAllFilters: () => void;
    // The resource table this filter is scoped to. When provided (advanced search),
    // it enables the "has related record" (reverse EXISTS) builder; left undefined
    // by the execution filter, which keeps its current behaviour.
    activeTab?: string;
}

export const CustomFilterField = ({
    form,
    matchingFields,
    filteredFieldList,
    values,
    clearAllFilters,
    activeTab,
}: CustomFilterFieldProps) => {
    // Relations available for the "has related record" (reverse EXISTS) builder on
    // this tab. Mirrors the gate in FilterGroup so the standalone add button below
    // only shows where an exists condition is actually valid.
    const relationOptions = useMatchingRelations({ activeTab });
    return (
        <div className="execution-search-filters advanced-search-filters">
            <Field name="customFilter">
                {({ input }) => {
                    return (
                        <FinalForm onSubmit={() => {}} initialValues={input.value}>
                            {({ form: nestedForm, submitFailed, values: nestedValues }) => {
                                // Trigger nested validation when parent submits
                                if (form?.getState().submitFailed && !submitFailed) {
                                    nestedForm.submit();
                                }
                                return (
                                    <>
                                        {Object.values(nestedValues || {})[0] ? (
                                            <FilterFragment
                                                parentData={nestedValues}
                                                formData={nestedValues}
                                                matchingFields={matchingFields}
                                                filteredFieldList={filteredFieldList}
                                                parentPath=""
                                                isRoot={true}
                                                setData={input.onChange}
                                                activeTab={activeTab}
                                            />
                                        ) : (
                                            <div className="addButtonContainer">
                                                <Button
                                                    onClick={() => {
                                                        input.onChange(
                                                            getUpdatedData(nestedValues, "", {
                                                                and: [emptyField],
                                                            })
                                                        );
                                                    }}
                                                    variation="white"
                                                    label="Add filter"
                                                />
                                                {relationOptions.length > 0 && (
                                                    <Button
                                                        onClick={() => {
                                                            input.onChange(
                                                                getUpdatedData(nestedValues, "", {
                                                                    and: [emptyExists],
                                                                })
                                                            );
                                                        }}
                                                        variation="white"
                                                        label="Has related record"
                                                    />
                                                )}
                                            </div>
                                        )}
                                        <FormSpy
                                            onChange={({ hasValidationErrors }) => {
                                                if (!form) return;
                                                if (hasValidationErrors) {
                                                    form.change("_hasNestedValidationErrors", true);
                                                } else {
                                                    form.change(
                                                        "_hasNestedValidationErrors",
                                                        false
                                                    );
                                                }
                                            }}
                                        />
                                    </>
                                );
                            }}
                        </FinalForm>
                    );
                }}
            </Field>
            <div
                className="submitFilterButtons"
                style={{
                    flex: Object.values(values.customFilter || {})[0] ? "0 0 100%" : "auto",
                }}
            >
                <Button
                    onClick={() => form?.submit()}
                    label="Search"
                    icon={IconCollection.magnify}
                    variation="dark"
                />
                <ClearSearchButton onClear={clearAllFilters} className="inlineBlock" />
            </div>
        </div>
    );
};
